import "./WaitTimesModal.scss"
import {IonCol, IonIcon, IonImg, IonModal, IonRow} from "@ionic/react";
import React, {FC, ReactNode, useMemo, useState} from "react";
import {useWaitTimes} from "../../helpers/waitTimesHelper";
import Button from "../Button";
import {baseUrl} from "../../helpers/configHelper";
import {timeOutline} from "ionicons/icons";

interface IWaitTimesModal {
    onDidDismiss: () => void;
    showing: boolean;
}

export const WaitTimesModal: FC<IWaitTimesModal> = ({showing, onDidDismiss}) => {
    const {
        waitingRange,
        waitingLabel,
    } = useWaitTimes();
    
    return <IonModal swipeToClose={true} isOpen={showing} onDidDismiss={onDidDismiss} cssClass="waiting-modal">
        <IonRow className="waiting-container">
            <IonCol className="waiting-text">
                <IonRow className="ion-justify-content-end">
                    <IonImg
                        onClick={() => onDidDismiss()}
                        src={`${baseUrl()}/images/assets/dismiss_button.svg`}
                    />
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <h2><strong>Current order wait time is</strong></h2>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <h2><strong>{waitingLabel} <span className="big-time-indicator">{waitingRange}</span> minutes</strong></h2>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <span>This is an estimate based on recent orders. Times may vary.</span>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <Button
                        onClick={onDidDismiss}
                        expand='block'
                        rounded={true}
                        size='large'
                        style={{width:'200px'}}
                    >
                        OK
                    </Button>
                </IonRow>
            </IonCol>
        </IonRow>
    </IonModal>
}

export const WaitTimesButton: FC<{onClick: () => void}> = ({onClick}) => {
    return <div className="wait-times-button" onClick={() => onClick()}>
        <span>Wait times</span>
        <IonIcon icon={timeOutline}/>
    </div>
}
